export class DialogModelUploadCreditError {
    constructor(
      public errorList: any,
      public message: String
    ) {}
  }